import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import Button from 'src/components/Common/@electron/Button';
import LazyImage from 'src/components/Common/LazyImage';
import track from 'src/lib/Analytics';
import { NewsBannerProps } from './types';

const NewsBanner = ({
  analytics,
  bgColor,
  body,
  image,
  link,
  title,
  isFullWidth,
}: NewsBannerProps) => {
  const textColor = bgColor === 'bg-blue' ? 'text-white' : 'text-gray-dark';
  const btnVariant = bgColor === 'bg-blue' ? 'primary-reversed' : 'secondary';

  // News Banner will set to the light Yellow Background with yellow line (at the top).
  const newsBannnerBgColor =
    bgColor === 'bg-yellow-dark/10'
      ? 'bg-yellow-dark/10 before:absolute before:top-0 before:inset-x-0 before:h-6 before:bg-yellow-dark'
      : bgColor;

  return (
    <section
      className={`relative p-16 sm:p-24 ${textColor} ${newsBannnerBgColor}${
        isFullWidth ? '' : ' container-4xl rounded-md overflow-clip w-full my-24'
      }`}
    >
      <div className="container-3xl flex flex-col sm:flex-row gap-y-8 sm:gap-x-24 items-center text-center sm:text-start">
        <div className="shrink-0">
          <LazyImage {...image} alt="" className="size-64 sm:size-80 rounded-full" />
        </div>

        <div className="grow flex flex-col gap-y-8">
          <Text id="news-banner-title" className="text-xl font-bold" field={title} tag="h2" />
          {body?.value && <RichText field={body} tag="div" />}
        </div>

        {link && (
          <div className="shrink-0 self-stretch sm:self-auto sm:ps-16">
            <Button
              id="news-banner-button"
              aria-labelledby="news-banner-button news-banner-title"
              variant={btnVariant}
              className="w-full max-w-[384px]"
              {...link}
              onClick={() => track.component(analytics)}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default NewsBanner;
